import type { FeatureAccessOptions } from '@blueshift-ui/auth/dist';

import useFeatureAccess from '@blueshift-ui/auth/dist/hooks/use-feature-access';

const criteria: FeatureAccessOptions = {
  productState: (userProductState) => userProductState === 'vt4s',
};

const useIsVt4sClient = () => useFeatureAccess({ criteria });

export default useIsVt4sClient;
